// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"Registrations-module_codeContainer__1-ueDhpV__3Q_CTQ89ApsQ"};